export interface IQuery { }

export class CurrentUserQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.CurrentUserQueryV1, TCh.Domain.Organizations'

	EnsureGlobalAdminRole: boolean
	EnsureOrganizationAdminRole: boolean
	EnsureAnyAdminRole: boolean

	constructor (ensureGlobalAdminRole: boolean, ensureOrganizationAdminRole: boolean, ensureAnyAdminRole: boolean)
	{
		this.EnsureGlobalAdminRole = ensureGlobalAdminRole
		this.EnsureOrganizationAdminRole = ensureOrganizationAdminRole
		this.EnsureAnyAdminRole = ensureAnyAdminRole
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.CurrentUserQueryV1, TCh.Domain.Organizations'
	}

}

export class OrganizationAdminCandidatesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.OrganizationAdminCandidatesQueryV1, TCh.Domain.Organizations'

	OrganizationUnitId: number

	constructor (organizationUnitId: number)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.OrganizationAdminCandidatesQueryV1, TCh.Domain.Organizations'
	}

}

export class PasswordPolicyQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.PasswordPolicyQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.PasswordPolicyQueryV1, TCh.Domain.Organizations'
	}

}

export class SearchAllUsersQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.SearchAllUsersQueryV1, TCh.Domain.Organizations'

	OrganizationUnitId: number
	SearchPhrase: string
	IncludeActive: boolean
	IncludeLocked: boolean
	IncludeDeleted: boolean
	IncludeServiceAccounts: boolean

	constructor (organizationUnitId: number, searchPhrase: string, includeActive: boolean, includeLocked: boolean, includeDeleted: boolean, includeServiceAccounts: boolean)
	{
		this.OrganizationUnitId = organizationUnitId
		this.SearchPhrase = searchPhrase
		this.IncludeActive = includeActive
		this.IncludeLocked = includeLocked
		this.IncludeDeleted = includeDeleted
		this.IncludeServiceAccounts = includeServiceAccounts
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.SearchAllUsersQueryV1, TCh.Domain.Organizations'
	}

}

export class StartupDetailsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.StartupDetailsQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.StartupDetailsQueryV1, TCh.Domain.Organizations'
	}

}

export class UserAccessRequestsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.UserAccessRequestsQueryV1, TCh.Domain.Organizations'

	OrganizationUnitId: number
	IncludeRequested: boolean
	IncludeRejected: boolean

	constructor (organizationUnitId: number, includeRequested: boolean, includeRejected: boolean)
	{
		this.OrganizationUnitId = organizationUnitId
		this.IncludeRequested = includeRequested
		this.IncludeRejected = includeRejected
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.UserAccessRequestsQueryV1, TCh.Domain.Organizations'
	}

}

export class UserDashboardQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.UserDashboardQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.UserDashboardQueryV1, TCh.Domain.Organizations'
	}

}

export class UserQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.Users.Queries.UserQueryV1, TCh.Domain.Organizations'

	UserId: string

	constructor (userId: string)
	{
		this.UserId = userId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.Users.Queries.UserQueryV1, TCh.Domain.Organizations'
	}

}

